export default String.raw`
.blog-post {
    &__main {
        flex-direction: column;
        padding: 0 32px 32px 32px;
    }

    &__article {
        width: 100%;
    }

    &__sidebar {
        width: 100%;
        align-items: center;
        gap: 0;
    }

    &__all-articles {
        @include h4-headline;
    }
}

.sidebar {
    &__header {
        padding-left: 0;
        padding-right: 0;
        @include h2-headline;
    }

    .blog-post__all-articles {
        display: none;
    }

    &__next-article,
    &__latests-posts {
        border: none;
    }

    &__next-article {
        .blog-item {
            flex-direction: row;
            align-items: stretch;
            justify-content: normal;
            padding: 0;

            &__title {
                margin: 0;
            }

            &__read {
                flex-direction: row;

                &-top {
                    align-items: center;
                    width: fit-content;
                }

                &-bottom {
                    &-time {
                        display: none;
                    }

                    &-button {
                        margin-left: auto;
                    }
                }
            }

            &__right-section {
                justify-content: space-evenly;
                padding: 0 20px;
                min-width: 66%;

                &-wrapper {
                    display: flex;
                    gap: 8px;
                    align-items: center;

                    span {

                        display: block;
                    }
                }
            }

            &__img {
                display: flex;
                justify-content: start;
                align-items: center;
            }

            >a {
                max-width: 28%;
                min-width: 28%;
                display: flex;
                align-items: center;
            }
        }
    }

    &__latests-posts {
        .blog-item {
            padding: 0;

            &__wrapper {
                gap: 16px;
            }

            &__title {
                display: block;
                @include h3-headline;
                white-space: nowrap;
            }

            &__content {
                display: block;
                height: 3lh;
                -webkit-line-clamp: 3;
                @include body-1-regular;
                margin-bottom: 8px;
            }

            &__read {
                display: flex;
                position: relative;
                flex-direction: row;
                justify-content: space-between;

                &-top {
                    flex-direction: column;
                    row-gap: 16px;

                    &-tags {
                        width: 100%;
                        order: 1;
                    }

                    time {
                        order: 2;
                        position: relative;
                        bottom: 2px;
                    }
                }

                &-bottom {
                    justify-content: end;
                    align-items: end;

                    &-time {
                        display: none;
                    }

                    &-button {
                        position: absolute;
                    }
                }
            }
        }

        .swiper {
            display: flex;
            width: 100%;
        }

        .swiper-slide {
            width: 33%;
        }

        .swiper-wrapper {
            flex-direction: row;
        }
    }

    >div {
        width: 100%;
        padding: 0;
    }
}
`